import { render, staticRenderFns } from "./Alertm.vue?vue&type=template&id=4c90a965&"
import script from "./Alertm.vue?vue&type=script&lang=js&"
export * from "./Alertm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports